import { render, staticRenderFns } from "./Promotion.vue?vue&type=template&id=98b93c92&scoped=true&"
import script from "./Promotion.vue?vue&type=script&lang=ts&"
export * from "./Promotion.vue?vue&type=script&lang=ts&"
import style0 from "./Promotion.vue?vue&type=style&index=0&id=98b93c92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b93c92",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsPercentage24px: require('/var/www/packages/theme/components/icons/percentage/Percentage24px.vue').default,IconsPercentage33px: require('/var/www/packages/theme/components/icons/percentage/Percentage33px.vue').default,AtomsPromotionBubble: require('/var/www/packages/theme/components/atoms/PromotionBubble.vue').default,AtomsImageOrFallback: require('/var/www/packages/theme/components/atoms/ImageOrFallback.vue').default})
